// extracted by mini-css-extract-plugin
export default {"view":"LoginView_view__LQ8b4","panel":"LoginView_panel__jmn2h","fadeInDown":"LoginView_fadeInDown__OeRYI"};